<template>
	<div class="full-fixed visible" id="js-spinner">
		<div class="sk-folding-cube">
			<div class="sk-cube1 sk-cube"></div>
			<div class="sk-cube2 sk-cube"></div>
			<div class="sk-cube4 sk-cube"></div>
			<div class="sk-cube3 sk-cube"></div>
		</div>
	</div>
</template>

<script>
/**
 * Composant permettant d'afficher un loader
 *
 * @version 1.0.0
 */
export default {
	name: 'Loader',
};
</script>

<style lang="scss" scoped>
@import '~@scss/style.scss';

#js-spinner {
	z-index: 5000;

	&:before {
		background-color: rgba(250, 250, 250, 1);
	}
}

div.full-fixed {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0;
	transition: all 0.3s ease-in-out;
	pointer-events: none;

	@include backdrop($opacity: 0.7);

	&.visible {
		opacity: 1;
		pointer-events: auto;
	}

	.sk-folding-cube {
		position: relative;
	}
}

.sk-folding-cube {
	position: relative;
	width: 40px;
	height: 40px;
	transform: rotateZ(45deg);
	margin: 20px auto;
	z-index: 5001;

	.sk-cube {
		float: left;
		width: 50%;
		height: 50%;
		position: relative;
		transform: scale(1.1);

		&:before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			// background-color: #333;
			background-color: $mainColor;
			animation: sk-foldCubeAngle 2.4s infinite linear both;
			transform-origin: 100% 100%;
		}

		&.sk-cube2 {
			transform: scale(1.1) rotateZ(90deg);

			&:before {
				animation-delay: 0.3s;
			}
		}

		&.sk-cube3 {
			transform: scale(1.1) rotateZ(180deg);

			&:before {
				animation-delay: 0.6s;
			}
		}

		&.sk-cube4 {
			transform: scale(1.1) rotateZ(270deg);

			&:before {
				animation-delay: 0.9s;
			}
		}
	}
}

@keyframes sk-foldCubeAngle {
	0%,
	10% {
		transform: perspective(140px) rotateX(-180deg);
		opacity: 0;
	}

	25%,
	75% {
		transform: perspective(140px) rotateX(0deg);
		opacity: 1;
	}

	90%,
	100% {
		transform: perspective(140px) rotateY(180deg);
		opacity: 0;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/global/Loader.vue